import React, { useState } from 'react';

import { Box } from '@mui/material';

import { CounterButton, CounterDisplay, CounterInput, CounterWrapper } from './NumberInput.styles';
import { sharedClasses } from '../sharedClasses';

import type { SxProps } from '@mui/material';
import type { ChangeEvent } from 'react';

interface NumberInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  id?: string;
  sx?: SxProps;
  buttonSx?: SxProps;
  inputSx?: SxProps;
  errorText?: string;
}

export const NumberInput = ({
  value,
  onChange,
  min,
  max,
  id,
  sx,
  buttonSx,
  inputSx,
  errorText
}: NumberInputProps) => {
  const [inputValue, setInputValue] = useState(String(value));

  const handleIncrement = () => {
    if (max === undefined || value < max) {
      onChange(value + 1);
      setInputValue(String(value + 1));
    }
  };

  const handleDecrement = () => {
    if (min === undefined || value > min) {
      onChange(value - 1);
      setInputValue(String(value - 1));
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    const numVal = Number(val);

    if (val.length > 3 || isNaN(numVal)) return;

    setInputValue(val);
    onChange(numVal);
  };

  return (
    <Box>
      <CounterWrapper sx={sx}>
        <CounterButton
          onClick={handleDecrement}
          sx={{ borderTopLeftRadius: 5, borderBottomLeftRadius: 5, ...buttonSx }}
        >
          -
        </CounterButton>
        <CounterDisplay>
          <CounterInput
            error={!!errorText}
            id={id}
            inputMode="numeric"
            onChange={handleInputChange}
            sx={inputSx}
            value={inputValue}
          />
        </CounterDisplay>
        <CounterButton
          onClick={handleIncrement}
          sx={{ borderTopRightRadius: 5, borderBottomRightRadius: 5, ...buttonSx }}
        >
          +
        </CounterButton>
      </CounterWrapper>
      {!!errorText && <Box sx={sharedClasses.errorText}>{errorText}</Box>}
    </Box>
  );
};
